import React from "react";
import "../styles/App.css";
import "../styles/time-table.css";
import { getTimeTable } from "../services/time-table-service";
import { Internationalization } from "@syncfusion/ej2-base";
import TimeTableDayEvent from "./day-event/Time-table-day-event";
import TimeTableWeekEvent from "./week-event/Time-table-week-event";
import RightSideCalender from "./day-event/RightSideCalender";
import SciencePopUp from "./PopUp/Science/SciencePopUp";
import { AiFillPlusCircle, AiFillEdit, AiFillDelete } from "react-icons/ai";
import ListHolidays from "./PopUp/listHolidays/ListHolidays";
import axios from "../../axios";
import StudyPlaner from "./PopUp/StudyPlaner/StudyPlaner";
import SummaryUpdated from "./SummaryUpdated/SummaryUpdated";
import EditStudyPlannerWeek from "./PopUp/StudyPlaner/EditStudyPlannerWeek";
import DeleteStudyPlannerWeekly from "./PopUp/StudyPlaner/DeleteStudyPlannerWeekly";
import SummaryNotGenrated from "./SummaryUpdated/SummaryNotGenrated";
import "intro.js/introjs.css";
import { Steps } from "intro.js-react";
import CalenderTour from "../../SidebarHeader/Header/CalenderTour";
import NewHolidaysList from "./PopUp/listHolidays/NewHolidaysList";
import TimeTableView from "./TimeTableView";
import StudyPlannerView from "./StudyPlannerView";
import HolidayList from "./HolidayList";
import SummaryLectureUi from "./SummaryLectureUi";

let firstdayDefault;
let lastdayDefault;

class SfTimeTable extends React.Component {
  constructor(props) {
    super(props);
    this.scheduleRef = React.createRef(); // 👈 same as useRef(null)
  }
  state = {
    events: [],
    createStudyPlanner: false,
    showSummary: false,
    listHoliday: false,
    dropDown: "",
    valDD: "",
    dateSelected: new Date(),
    clickCount: 0,
    selectedEvent: null,
    editValue: null,
    openEdit: false,
    openDelete: false,
    supplementId: null,
    openNoSummary: false,
    viewSummaryClick: false,
    activity: [],
    assessment: [],
    homework: [],
    preRead: [],
    stepsEnabled: false,
    initialStep: 0,
    homeScreenWalkThroughPopup: false,
    alreadyStartDate: null,
    alreadyEndDate: null,
    firstday: null,
    lastday: null,
    lactureType: 1,
    allLactursByType: [],
    holidaysArray: [],
    allHolidays: [],
    loading: false,
    activeHeader: 'Timetable',
    searchParams: {},
    //    let [searchParams, setSearchParams] = useSearchParams({
    //   header: "",
    // });
    steps: [
      {
        element: ".home",
        intro: `
            <h3>Home</h3>
            <p>Home has 4 features (as shown in left most pane):
           </p>
           <ol>
              <li>My Feed</li>
              <li>Library</li>
              <li>Calendar</li>
            </ol>
          `,
        position: "top",
        tooltipClass: "myTooltipClass",
        highlightClass: "myHighlightClass",
      },
      {
        element: ".featuredLeftPane",
        intro: `
            <h3>Features Group Left Pane
            Home has 3 features as shown:</h3>
            <ol>
              <li>My Feed</li>
              <li>Library</li>
              <li>Calendar</li>
            </ol>
          `,
        position: "top",
        tooltipClass: "myTooltipClass",
        highlightClass: "myHighlightClass",
      },
      {
        element: ".calender",
        intro: `
            <h3>Calender</h3>
            <p>Currently 'Calender' feature is selected</p>
          `,
        position: "top",
        tooltipClass: "myTooltipClass",
        highlightClass: "myHighlightClass",
      },
      {
        element: ".weeklyDatesPane",
        intro: `
            <h3>Weekly Dates Pane</h3>
            <p>You will find 7 Dates for the Week Count shown above to it.
            You can Click over any Date to See Timetable for that Date.</p>
          `,
        position: "top",
        tooltipClass: "myTooltipClass",
        highlightClass: "myHighlightClass",
      },
      {
        element: ".selDate",
        intro: `
            <h3>Selected Date</h3>
            <p>
            It shows the Selected Date and Day in Weekly Dates Pane'. Timetable is displayed below for this Date.</p>
          `,
        position: "top",
        tooltipClass: "myTooltipClass",
        highlightClass: "myHighlightClass",
      },
      {
        element: ".weekPans",
        intro: `
            <h3>Week Pane</h3>
            <p>
            It shows the Week Number, Month and Yeat
You can move to different Weeks here and Select Date in Weekly Dates Pane' below to fetch Timeta
selected Date</p>
          `,
        position: "top",
        tooltipClass: "myTooltipClass",
        highlightClass: "myHighlightClass",
      },

      {
        element: ".dailyTTPane",
        intro: `
            <h3>Daily Time Table Pane</h3>
            <p>
            It shows daily timetable (Lectures and your study planners)</p>
          `,
        position: "top",
        tooltipClass: "myTooltipClass",
        highlightClass: "myHighlightClass",
      },

      {
        element: ".e-toolbar-right",
        intro: `
            <h3>Daily/Weekly Time Table session</h3>
            <p>
            You can select daily or weekly time table form here</p>
          `,
        position: "top",
        tooltipClass: "myTooltipClass",
        highlightClass: "myHighlightClass",
      },
      {
        element: ".studyPlanner",
        intro: `
            <h3>Create Study Planner</h3>
            <p>
            You can create study planner form here</p>
          `,
        position: "top",
        tooltipClass: "myTooltipClass",
        highlightClass: "myHighlightClass",
      },
      {
        element: ".lectureStudyPlanner",
        intro: `
            <h3>Lecture and Study Planner Section</h3>
            <p>
            If you wish you can select to see only lectures or only study planners from here</p>
          `,
        position: "top",
        tooltipClass: "myTooltipClass",
        highlightClass: "myHighlightClass",
      },
      {
        element: ".holidaysList",
        intro: `
            <h3>Holidays List</h3>
            <p>
            You can find holidays list here</p>
          `,
        position: "top",
        tooltipClass: "myTooltipClass",
        highlightClass: "myHighlightClass",
      },
      {
        element: ".prifilePic",
        intro: `
            <h3>Your profile, B4S App layout</h3>
            <p>Access your profile Information.</p>
          `,
        position: "top",
        tooltipClass: "myTooltipClass",
        highlightClass: "myHighlightClass",
      },
      {
        element: ".done",
        intro: `
            <h3>Awesome, you are done. 😊</h3>
            <p>Click anywhere on the screen or click on the cross icon.</p>
          `,
        position: "top",
        tooltipClass: "myTooltipClass",
        highlightClass: "myHighlightClass",
      },
    ],
  };

  formatDate(dateString) {
    const date = new Date(dateString);
    const month = date.toLocaleString("default", { month: "short" });
    const day = date.getDate();
    return `${month} ${day}`;
  }
  // holidaysArray = [];

  instance = new Internationalization();
  scheduleObj = null;

  componentDidMount = async (startDate, endDate) => {
    const hasShownPopup = localStorage.getItem('hasShownPopupCalender');
    if (!hasShownPopup) {
      this.setState({ homeScreenWalkThroughPopup: true });
      localStorage.setItem('hasShownPopupCalender', 'true');
    }
    if (startDate === undefined) {
      this.handelDateChangeDefault();
      this.state.alreadyStartDate = (new Date(firstdayDefault)).getDate()
      this.state.alreadyEndDate = (new Date(lastdayDefault)).getDate()
      try {
        this.setState({ loading: true });
        const eventsData = await getTimeTable(firstdayDefault, lastdayDefault);
        let events = eventsData[this.state.lactureType];
        this.setState({
          allLactursByType: eventsData,
          events: events,
          valDD: this.state.lactureType,
        });
      } catch (error) {
        console.error("Failed to fetch default events data:", error);
        this.setState({ loading: false });
      }
      this.setState({ loading: false });
    } else {
      if (((new Date(startDate)).getDate() == this.state.alreadyStartDate) && ((new Date(endDate)).getDate() == this.state.alreadyEndDate)) {
        return false;
      }
      this.state.alreadyStartDate = (new Date(startDate)).getDate()
      this.state.alreadyEndDate = (new Date(endDate)).getDate()
      try {
        this.setState({ loading: true });
        const eventsData = await getTimeTable(startDate, endDate);
        let events = eventsData[this.state.lactureType];
        this.setState({
          allLactursByType: eventsData,
          events: events,
          valDD: this.state.lactureType,
        });
      } catch (error) {
        console.error("Failed to fetch custom events data:", error);
        this.setState({ loading: false });
      }
      this.setState({ loading: false });
    }
  };


  handleSupplementId = (id) => {
    this.setState({ supplementId: id });
  };


  dayEventTemplate(events) {
    return (
      <TimeTableDayEvent
        event={events}
        summaryShowToday={this.summaryShowToday}
        handleId={this.handleSupplementId}
      />
    );
  }


  weekEventTemplate(events) {
    return <TimeTableWeekEvent event={events} />
  }

  handleScheduleClick = () => {
    this.setState((prevState) => ({
      clickCount: prevState.clickCount + 1,
    }));

    setTimeout(() => {
      this.setState({ clickCount: 0 });
    }, 300);
  };

  onCreated() {
    this?.scheduleObj?.scrollTo(
      this?.instance?.formatDate(new Date(), { skeleton: "hm" })
    );
    this.handleHolidayList();
    localStorage.setItem("dropdownval", "0");
    this?.scheduleObj?.element?.addEventListener(
      "click",
      this.handleScheduleClick
    );
  }

  onEventRendered(args) {
    const currentTime = new Date();
    const isHappened = currentTime.getTime() > args.data?.EndTime?.getTime();
    if (isHappened && (args.data.lectureType !== "general_category" && args.data.Events[0] !== "Planner")) {
      args.element.style.backgroundColor = args.data.DisplayColor;
      args.element.style.opacity = "0.5";
    } else if (args.data.lectureType === "general_category") {
      args.element.style.backgroundColor = "#F9F9F9";
    } else if (isHappened && (args.data.Events[0] === "Planner")) {
      args.element.style.backgroundColor = "#F9F9F9";
      args.element.style.color = "black";
      args.element.style.borderLeft = `6px solid ${args.data.DisplayColor}`;
    } else if (!isHappened && (args.data.Events[0] === "Planner")) {
      args.element.style.backgroundColor = "#F9F9F9";
      args.element.style.borderLeft = "5px solid" + args.data.DisplayColor;
    } else {
      args.element.style.backgroundColor = args.data.DisplayColor;
    }
  }

  handleDateChange = (currentDate) => {
    this.setState(
      {
        dateSelected: currentDate,
      },
      () => {
        var curr = new Date(currentDate); // Convert currentDate to Date object
        var first = curr.getDate() - curr.getDay(); // Get the first day of the week
        var last = first + 6; // Get the last day of the week
        var firstDayOfWeek = new Date(curr.setDate(first)); // Create a Date object for the first day of the week
        var lastDayOfWeek = new Date(firstDayOfWeek); // Copy the first day of the week to modify it for the last day
        lastDayOfWeek.setDate(lastDayOfWeek.getDate() + 6); // Set it to the last day of the week
        this.scheduleRef?.refresh();
        this.componentDidMount(firstDayOfWeek, lastDayOfWeek);
      }
    );
  };

  handelDateChangeDefault = () => {
    let today = new Date();
    let dayOfWeek = today.getUTCDay();
    let firstDay = new Date(today);
    firstDay.setUTCDate(today.getUTCDate() - dayOfWeek);
    let lastDay = new Date(today);
    lastDay.setUTCDate(today.getUTCDate() + (6 - dayOfWeek));
    firstdayDefault = firstDay.toUTCString();
    lastdayDefault = lastDay.toUTCString();
  };



  headerTemplate(events) {
    if (events?.Id) {
      const currentTime = new Date();
      const isHappened = currentTime.getTime() > events?.EndTime?.getTime();
      return events.lectureType === "general_category" ? (
        <div className="quick-info-header">
          <div className="quick-info-header-content">
            <div
              className="heder_template"
              style={{
                background: isHappened ? "#808080" : events?.DisplayColor,
              }}
            >
              {/* <span
                className="quick-info-edit-icon"
                onClick={() => this.editEvent(event)}
              >
                <AiFillEdit
                  size={20}
                  color="white"
                  style={{
                    marginRight: "8px",
                    marginLeft: "300px",
                    marginTop: "10px",
                  }}
                />
              </span>
              <span
                className="quick-info-delete-icon"
                onClick={() => this.deleteEvent(event)}
              >
                <AiFillDelete
                  size={20}
                  color="white"
                  style={{ marginRight: "8px", marginTop: "10px" }}
                />
              </span> */}
            </div>
          </div>
        </div>
      ) : (
        <div className="quick-info-header">
          <div className="quick-info-header-content">
            <div
              className="heder_template1"
              style={{
                background: isHappened ? "#808080" : events?.DisplayColor,
              }}
            ></div>
          </div>
        </div>
      );
    }
  }
  handleShowHolidaysClose = () => {
    this.setState({ listHoliday: false });
  };

  closeTimeTablePopup = async () => {
    this.closePopup();
  };


  contentTemplate(props) {
    return props ? (
      <>
        <div className="quick-info-content">
          {props?.elementType !== "cell" && (

            // <SciencePopUp
            //   event={props}
            //   open1={() => {
            //     this.setState({ openNoSummary: true });
            //   }}
            // />
            <SummaryLectureUi
              event={props}
              scheduleRef={this.scheduleRef}
            />
          )}
        </div>
      </>
    ) : (
      <></>
    );
  }

  onCellClick() {
    return null;
  }

  studyPlannerDeactive = () => {
    this.setState({ createStudyPlanner: false });
  };

  summaryShowToday = () => {
    this.setState({ showSummary: true });
  };

  CloseSummaryShowToday = () => {
    this.setState({ showSummary: false });
  };

  handleCross = (para) => {
    this.setState({ listHoliday: para });
  };

  handleCellDoubleClick = (args) => {
    args.preventDefault();
  };

  handleOpenSummaryPopup = () => {
    this.setState({ openNoSummary: true });
  };

  handleCloseSummaryPopup = () => {
    this.setState({ openNoSummary: false });
  };


  formatDate1 = (dateString) => {
    const date = new Date(dateString);
    const month = date.toLocaleString("default", { month: "short" });
    const day = date.getDate();
    return `${month} ${day}`;
  };

  onPopupOpen(args) {
    try {
      console.log(args)
      if (args.type === "Editor") {
        args.cancel = true;
      }
      if (args.type === "Editor" && args.data.Events[0] === "Planner") {
        args.cancel = true;
        this.setState({ selectedEvent: args });
      }
      if (args.type === "RecurrenceAlert") {
        args.cancel = true;
      }
      if (
        args.type === "RecurrenceAlert" &&
        args.data.Events[0] === "Planner"
      ) {
        args.cancel = true;
      }
      if (args.type === "QuickInfo" && !args.data.Id) {
        args.cancel = true;
      }
      if (args.type === "QuickInfo" && args.data.lectureType === "general_category") {
        args.cancel = true;
      }
    } catch (error) {
      console.log(error);
    }
  }

  // editorTemplate(props) {
  //   try {
  //     return props !== undefined ? (
  //       <>
  //         <EditStudyPlannerWeek event={props} />
  //       </>
  //     ) : (
  //       <></>
  //     );
  //   } catch (error) {
  //     console.log(error);
  //   }
  // }
  details = JSON.parse(localStorage.getItem("breathForStudent"));

  handleHolidayList = async () => {
    try {
      let res = await axios.get(
        `/school/holiday/get/academicYear/${this.details.academic_year.id}`
      );
      const holidaysByMonth = res.data.data.reduce((result, holiday) => {
        const startDate = holiday.start_date;
        const endDate = holiday.end_date;
        const holidayObj = {
          startDate: startDate,
          endDate: endDate,
          name: holiday.name,
        };
        const month = startDate.split(" ")[0];
        if (!result[month]) {
          result[month] = {
            Month: month,
            holidays: [],
          };
        }
        result[month].holidays.push(holidayObj);
        return result;
      }, {});

      // Store Object.values(holidaysByMonth) in the state
      this.setState(
        { holidaysArray: Object.values(holidaysByMonth) },
        () => {
          // Callback to ensure holidaysArray is updated
          this.setState(
            {
              allHolidays: this.state.holidaysArray
                .map((item) => item.holidays)
                .flat()
            }, () => {
              console.log("this.state.allHolidays", this.state.allHolidays);
            }
          )
        }
      );
    } catch (error) {
      console.error("Error fetching holidays:", error);
    }
  };



  editEvent = (event) => {
    this.setState({
      editValue: event,
      openEdit: true,
    });
  };
  deleteEvent = (event) => {
    this.setState({
      editValue: event,
      openDelete: true,
    });
  };
  getCurrentFormattedDate(date) {
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    const daysOfWeek = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];

    // const currentDate = new Date();
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    const dayOfWeek = daysOfWeek[date.getDay()];
    const formattedDate = `${day} ${month} ${year}, ${dayOfWeek}`;
    return formattedDate;
  }



  onExit = () => {
    this.setState({ stepsEnabled: false });
  };

  setHomeScreenWalkThroughPopup = (value) => {
    this.setState({ homeScreenWalkThroughPopup: value });
  };

  setStepsEnabled = (value) => {
    this.setState({ stepsEnabled: value });
  };
  onActionBegin = (args) => {
    if (args?.event?.target?.innerText === 'TODAY' || args?.event?.target?.innerText === 'Today') {
      var curr = new Date();
      var first = curr.getDate() - curr.getDay();
      var firstDayOfWeek = new Date(curr.setDate(first));
      var lastDayOfWeek = new Date(firstDayOfWeek);
      lastDayOfWeek.setDate(lastDayOfWeek.getDate() + 6);
      this.scheduleRef?.refresh();
      this.componentDidMount(firstDayOfWeek, lastDayOfWeek);
    }
  };
  onDragStart = (args) => {
    args.cancel = true; // Disable drag operation
  };

  onResizeStart = (args) => {
    args.cancel = true; // Disable resize operation
  };

  handleShowHolidays = () => {
    this.setState({ listHoliday: true });
  };


  handleLactureTypeChange = (newType) => {
    this.setState({ lactureType: newType });
  };

  handleShowStudyPlannerPopup = () => {
    this.setState({ createStudyPlanner: true })
  }

  render() {
    const { stepsEnabled, steps, initialStep, homeScreenWalkThroughPopup } = this.state;
    return (
      <>
        <Steps
          enabled={stepsEnabled}
          steps={steps}
          initialStep={initialStep}
          onExit={this.onExit}
        />
        <div className="me-3">
          <div className="mb-3 d-flex align-items-center justify-content-between flex-wrap">
            <div className="col-md-3 p-0 five_component_CM">
              <button
                className={` ${this.state.activeHeader === "Timetable"
                  ? " cm_five_active_btn"
                  : "cm_five_btn"
                  }`}
                onClick={(e) => {
                  this.setState({ activeHeader: "Timetable" });
                  const params = new URLSearchParams(window.location.search);
                  params.set("header", "Timetable");
                  window.history.replaceState({}, "", `${window.location.pathname}?${params}`);
                }}
              >
                Timetable
              </button>
              <button
                className={` ${this.state.activeHeader === "StudyPlanner"
                  ? " cm_five_active_btn"
                  : "cm_five_btn"
                  }`}
                onClick={(e) => {
                  this.setState({ activeHeader: "StudyPlanner" });
                  const params = new URLSearchParams(window.location.search);
                  params.set("header", "StudyPlanner");
                  window.history.replaceState({}, "", `${window.location.pathname}?${params}`);
                }}
              >
                Study Planner
              </button>
            </div>
          </div>
          <div>
            {this.state.activeHeader === "Timetable" && (
              <TimeTableView
                type='Timetable'
                loading={this.state.loading}
                scheduleRef={(schedule) => {
                  this.scheduleObj = schedule;
                  this.scheduleRef = schedule;
                }}
                onActionBegin={this.onActionBegin}
                dateSelected={this.state.dateSelected}
                eventRendered={this.onEventRendered.bind(this)}
                eventSettings={{
                  dataSource:
                    this.state.allLactursByType?.[1] ||
                    this.state.events?.[1] ||
                    [],
                }}
                dragStart={this.onDragStart}
                resizeStart={this.onResizeStart}
                cellDoubleClick={this.onCellClick.bind(this)}
                quickInfoTemplates={{
                  header: this.headerTemplate.bind(this),
                  content: this.contentTemplate.bind(this),
                }}
                onCreated={this.onCreated.bind(this)}
                onPopupOpen={this.onPopupOpen.bind(this)}
                dayEventTemplate={this.dayEventTemplate.bind(this)}
                weekEventTemplate={this.weekEventTemplate.bind(this)}
                handleDateChange={this.handleDateChange}
                onShowHolidays={this.handleShowHolidays}
                getCurrentFormattedDate={this.getCurrentFormattedDate}
              />
            )}
            {this.state.activeHeader === "StudyPlanner" && (

              <StudyPlannerView
                type='StudyPlanner'
                getCurrentFormattedDate={this.getCurrentFormattedDate}
                dateSelected={this.state.dateSelected}
                handleDateChange={this.handleDateChange}
                onShowHolidays={this.handleShowHolidays}
                onLactureTypeChange={this.handleLactureTypeChange}
                onShowStudyPlannerPopup={this.handleShowStudyPlannerPopup}
                createStudyPlanner={this.state.createStudyPlanner}
                studyPlannerDeactive={this.studyPlannerDeactive}
                studentDetails={this.details}
                dropDown={this.state.dropDown}
                loading={this.state.loading}
                scheduleRef={(schedule) => {
                  this.scheduleObj = schedule;
                  this.scheduleRef = schedule;
                }}
                onActionBegin={this.onActionBegin}
                eventRendered={this.onEventRendered.bind(this)}
                eventSettings={{
                  dataSource:
                    this.state.allLactursByType?.[2] ||
                    this.state.events?.[2] ||
                    [],
                }}
                dragStart={this.onDragStart}
                resizeStart={this.onResizeStart}
                cellDoubleClick={this.onCellClick.bind(this)}
                quickInfoTemplates={{
                  header: this.headerTemplate.bind(this),
                  content: this.contentTemplate.bind(this),
                }}
                onCreated={this.onCreated.bind(this)}
                onPopupOpen={this.onPopupOpen.bind(this)}
                dayEventTemplate={this.dayEventTemplate.bind(this)}
                weekEventTemplate={this.weekEventTemplate.bind(this)}
              />

            )}
            {/* {create.createContent && <CreateContentCM setCreate={setCreate} />} */}
          </div>
        </div>
        <div className="gap-4 d-flex">
          <div
          >
            <div className="top_of_dcm mt-1">
              {/* <div className="DcmTodaysDate selDate">
                {this.getCurrentFormattedDate(this.state.dateSelected)}
              </div> */}
              <div className="d-flex gap-3 ">
                {/* <div
                  className="d-flex align-items-center addStudeyPlanner studyPlanner"
                  onClick={() => this.setState({ createStudyPlanner: true })}
                >
                  <AiFillPlusCircle /> &nbsp;<span>Add Study Planner</span>
                </div> */}
                <div className="lectureStudyPlanner">
                  {/* <select
                    className="form-select DcmDropdownAll"
                    aria-label="Default select example"
                    onChange={(e) => {
                      localStorage.setItem("dropdownval", JSON.stringify(e.target.value));
                      console.log("lactureType", this.state.lactureType)
                      console.log("e.target", e.target.value)
                      this.setState({ lactureType: e.target.value })
                    }}
                  > */}
                  {/* <select
                    className="form-select DcmDropdownAll"
                    aria-label="Default select example"
                    onChange={(e) => {
                      const selectedValue = e.target.value;
                      localStorage.setItem("dropdownval", selectedValue);
                      this.setState(
                        { lactureType: selectedValue }
                      );
                    }}
                  >
                    <option value="0" selected>
                      All
                    </option>
                    <option value="1">Lecture Session</option>
                    <option value="2">Study Planner</option>
                  </select> */}
                </div>
                {/* <button
                  className="listHolidaysBtn holidaysList"
                  onClick={() => this.setState({ listHoliday: true })}
                >
                  List of Holidays
                </button> */}
              </div>
            </div>
            {/* make calender scrollable */}

            {/* {this.state.loading ? (
              <div>Loading...</div>
            ) : (<ScheduleComponent
              className="dailyTTPane"
              ref={(schedule) => {
                this.scheduleObj = schedule;
                this.scheduleRef = schedule;
              }}
              // cssClass="schedule-overview"
              height="510px"
              width="100%"
              currentView="Week"
              startHour="06:00"
              endHour="24:00"
              actionBegin={this.onActionBegin}
              selectedDate={this.state.dateSelected}
              eventRendered={this.onEventRendered.bind(this)}
              eventSettings={{
                dataSource: this.state.allLactursByType?.[this.state.lactureType] || this.state.events?.[this.state.lactureType] || [],
              }}
              timeScale={{
                enable: true,
                interval: 30,
                slotCount: 1,
              }}
              dragStart={this.onDragStart}
              resizeStart={this.onResizeStart}
              cellClick={null}
              cellDoubleClick={this.onCellClick.bind(this)}
              quickInfoTemplates={{
                header: this.headerTemplate.bind(this),
                content: this.contentTemplate.bind(this),
              }}
              //allowDragAndDrop={}
              created={this.onCreated.bind(this)}
              // editorTemplate={this?.editorTemplate?.bind(this)}
              popupOpen={this.onPopupOpen.bind(this)}
            >
              <ViewsDirective>
                <ViewDirective
                  option="Day"
                  eventTemplate={this.dayEventTemplate.bind(this)}
                />
                <ViewDirective
                  option="Week"
                  eventTemplate={this.weekEventTemplate.bind(this)}
                />
              </ViewsDirective>
              <Inject services={[Day, Week, Resize]} />
            </ScheduleComponent>
            )
            } */}

          </div>
          {/* <div className="righ_side_box">
            <RightSideCalender change1={this.handleDateChange} />
          </div> */}
        </div>


        {/* {this.state.listHoliday && (
          // <ListHolidays
          //   setListHolidays={this.handleCross}
          //   holidaysArray={this.holidaysArray}
          // />
          <NewHolidaysList
            setListHolidays={this.handleCross}
            holidaysArray={this.state.allHolidays}
          />
        )} */}

        {this.state.listHoliday && (
          <HolidayList holidaysArray={this.state.allHolidays} handleShowHolidaysClose={this.handleShowHolidaysClose} />
        )}
        {this.state.showSummary && !this.state.openNoSummary && (
          <SummaryUpdated
            CloseSummaryShowToday={() => {
              this.CloseSummaryShowToday();
            }}
            data={this.state.supplementId}
            open={() => {
              this.setState({ openNoSummary: true });
            }}
            show={this.state.openNoSummary}
          />
        )}
        {/* {this.state.openEdit && (
          <EditStudyPlannerWeek
            event={this.state.editValue}
            close={() => {
              this.setState({ openEdit: false });
            }}
          />
        )} */}
        {this.state.openDelete && (
          <DeleteStudyPlannerWeekly
            event={this.state.editValue}
            close={() => {
              this.setState({ openDelete: false });
            }}
          />
        )}
        {homeScreenWalkThroughPopup && (
          <CalenderTour
            setHomeScreenWalkThroughPopup={this.setHomeScreenWalkThroughPopup}
            setStepsEnabled={this.setStepsEnabled}
          />
        )}
        {this.state.openNoSummary && (
          <SummaryNotGenrated
            CloseSummaryShowToday={() => {
              this.CloseSummaryShowToday();
            }}
            close={() => {
              this.setState({ openNoSummary: false });
            }}
          />
        )}
      </>
    );
  }
}

export default SfTimeTable;
